
export default function selectOnFocus(e) {
    const target = e.target;
    
    // Ensure the input is focused first
    if (document.activeElement !== target) {
        target.focus();
    }
    
    // Small delay to ensure focus is complete before selecting
    setTimeout(() => {
        if (target && typeof target.select === 'function') {
            target.select();
        }
    }, 0);
}